import React from 'react';

import SearchEventsRecommended from '../../searches/SearchEventsRecommended';
import CTA from '@molecules/CTA';
import LoadingArea from '@molecules/LoadingArea';
import { DivWithShadowMediumUp, H4 } from '@styled';

import useEventsRecommendedFilters from '../../../hooks/algoliaFilters/useEventsRecommendedFilters';

const EventsRecommended = () => {
    const { filters } = useEventsRecommendedFilters();

    if (filters.length === 0) {
        return <LoadingArea />;
    }

    return (
        <div>
            <H4 className="mb-1.5rem">Recommended Events</H4>

            <DivWithShadowMediumUp>
                <div className="mb-2rem">
                    <CTA
                        headerText="Your connections will be attending these events — register to join them!"
                        ctaText="See All Upcoming Events"
                        ctaUrl={`${window.location.protocol}//${window.location.host}/search?type=events`}
                        showLarge
                    />
                </div>

                <SearchEventsRecommended />
            </DivWithShadowMediumUp>
        </div>
    );
};

export default EventsRecommended;
